import { RootState } from 'store';
import { IApplicantDetail, IApplicantRow } from 'types/employee/IJobApplicant';

export const applicantsSelector = (state: RootState): IApplicantRow[] => state.jobApplicants.applicants;
export const applicantsLoadingSelector = (state: RootState): boolean => state.jobApplicants.loading;
export const applicantsErrorSelector = (state: RootState): string | null => state.jobApplicants.error;
export const numberOfApplicantsSelector = (state: RootState): number | null => state.jobApplicants.numberOfApplicants;
export const applicantsCurrentPageSelector = (state: RootState): number => state.jobApplicants.currentPage;

export const applicantDetailSelector = (state: RootState): IApplicantDetail | null =>
  state.jobApplicants.applicantDetail;
export const applicantDetailLoadingSelector = (state: RootState): boolean => state.jobApplicants.applicantDetailLoading;
export const applicantDetailErrorSelector = (state: RootState): string | null =>
  state.jobApplicants.applicantDetailError;
export const applicantActionLoadingSelector = (state: RootState): boolean => state.jobApplicants.applicantActionLoading;
export const applicantActionErrorSelector = (state: RootState): string | null =>
  state.jobApplicants.applicantActionError;
export const applicantCvDownloadErrorSelector = (state: RootState): boolean => state.jobApplicants.cvDownloadError;
export const promoteSuccessMessageSelector = (state: RootState): string | null =>
  state.jobApplicants.promoteSuccessMessage;

export const canLoadMoreApplicantsSelector = (state: RootState): boolean => {
  const { currentPage, totalPages } = state.jobApplicants;
  if (totalPages === null) return true;
  return currentPage < totalPages;
};
